import React, { memo } from 'react'
import SlickSlider from 'react-slick'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import useStyles from './Slider.styled'

const Slider = React.forwardRef((props, ref) => {
	const classes = useStyles()

	return <SlickSlider ref={ref} {...props} className={clsx(classes.root, props.className)} />
})

Slider.propTypes = {
	children: PropTypes.node.isRequired,
	accessibility: PropTypes.bool,
	adaptiveHeight: PropTypes.bool,
	afterChange: PropTypes.func,
	appendDots: PropTypes.func,
	arrows: PropTypes.bool,
	asNavFor: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.instanceOf(Element) }), // If you pass a ref object
	]),
	autoplay: PropTypes.bool,
	autoplaySpeed: PropTypes.number,
	beforeChange: PropTypes.func,
	centerMode: PropTypes.bool,
	centerPadding: PropTypes.string,
	className: PropTypes.string,
	customPaging: PropTypes.func,
	dots: PropTypes.bool,
	dotsClass: PropTypes.string,
	draggable: PropTypes.bool,
	easing: PropTypes.string,
	fade: PropTypes.bool,
	focusOnSelect: PropTypes.bool,
	infinite: PropTypes.bool,
	initialSlide: PropTypes.number,
	lazyLoad: PropTypes.oneOf(['ondemand', 'progressive']),
	onEdge: PropTypes.func,
	onInit: PropTypes.func,
	onLazyLoad: PropTypes.func,
	onReInit: PropTypes.func,
	onSwipe: PropTypes.func,
	pauseOnDotsHover: PropTypes.bool,
	pauseOnFocus: PropTypes.bool,
	pauseOnHover: PropTypes.bool,
	responsive: PropTypes.arrayOf(
		PropTypes.shape({
			breakpoint: PropTypes.number.isRequired,
			settings: PropTypes.object.isRequired,
		}),
	),
	rows: PropTypes.number,
	rtl: PropTypes.bool,
	slide: PropTypes.string,
	slidesPerRow: PropTypes.number,
	slidesToScroll: PropTypes.number,
	slidesToShow: PropTypes.number,
	speed: PropTypes.number,
	swipe: PropTypes.bool,
	swipeToSlide: PropTypes.bool,
	touchMove: PropTypes.bool,
	touchThreshold: PropTypes.number,
	useCSS: PropTypes.bool,
	useTransform: PropTypes.bool,
	variableWidth: PropTypes.bool,
	vertical: PropTypes.bool,
}

export default memo(Slider)
